import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import { RoutePath } from '../../layout/Routes'

import { AiChat } from '@percent/domain/ai-chat'
import { INSIGHTS_AI_EXAMPLE_QUESTION_KEYS } from './exampleQuestions'

/**
 * The natural-language insights entry point on the dashboard: the generic ai-chat
 * question box, bound to insights copy and example prompts. It answers nothing inline
 * — every ask opens the "Ask about your impact" chat page, carrying the question in
 * router state. Gated by the caller (feature flag + `partner_insights` scope).
 */
export function InsightsAiQuestionBox() {
  const { t } = useTranslation()
  const navigate = useNavigate()

  return (
    <AiChat.QuestionBox
      prompts={INSIGHTS_AI_EXAMPLE_QUESTION_KEYS.map(key => ({ id: key, label: t(key) }))}
      onAsk={question => navigate(RoutePath.ASK_IMPACT, { state: { initialQuestion: question } })}
      placeholder={t('typography.dashboard.insightsAi.inputPlaceholder')}
      submitLabel={t('typography.dashboard.insightsAi.ask')}
      betaLabel={t('typography.dashboard.beta')}
      testId="insights-ai-question-box"
      examplesTestId="insights-ai-examples"
      inputTestId="insights-ai-input"
      submitTestId="insights-ai-submit"
      chipTestId={key => `insights-ai-chip-${key}`}
      inputName="insights-ai-question"
    />
  )
}
